<div class="pos-f-t fixed-top header">
  <nav class="navbar navbar-inverse bg-inverse navbar-toggleable-md">
    <button
      class="d-block d-sm-block d-md-block d-lg-none d-xl-none navbar-toggler navbar-toggler-right"
      (click)="toggleSidebar()"
    >
      <span class="navbar-toggler-icon">
        <em class="fa fa-navicon"></em>
      </span>
    </button>
    <div class="d-flex align-self-center col-12 note">
      <img
        class="d-flex align-self-center mr-3"
        src="\assets\images\UnifyLogo.png"
        alt="Generic placeholder image"
        height="37px"
        style="cursor: pointer"
        (click)="redirectToPortalDashboard()"
      />
      NOTE: This page is being redesigned and will be relocated. Please review the<a [attr.href]="releaseNotesUrl"  style="margin-left: 0.5rem;margin-right: 0.5rem">release notes</a>for more details.
    </div>

    <div class="collapse navbar-collapse">
      <ul class="navbar-nav ml-auto mt-2 mt-md-0">
        <li class="nav-item dropdown">
          <span style="color: #636368">
            <em class="fa fa-user"></em>
            {{ details.userId }}
          </span>
        </li>
      </ul>
    </div>
  </nav>
</div>
